var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#ED1B2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "pd-arrow-up_svg__lucide pd-arrow-up_svg__lucide-chevron-up pd-arrow-up_svg__w-4 pd-arrow-up_svg__h-4 pd-arrow-up_svg__transition-transform"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15l6-6 6 6"
  })));
}

export default SvgPdArrowUp;